/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import farmerDevices from './farmer-devices/farmer-devices.directive';
import devicesDashboard from './dashboard/devices-dashboard.directive';
import deviceDashboardWidget from  './dashboard/device-dashboard-widget.directive';
import devicesMap from './map/devices-map.directive';
import measurementsMap from './map/measurements-map';
import allMeasurementsMap from './map/all-measurements-map';
import farmerPhoto from './photo/farmer-photo.directive';

import farmerDeviceDetails from './farmer-device-details/farmer-device-details.directive';
import manualDevice from './manual-devices/manual-device.directive';
import superProMeasurements from './manual-devices/super-pro/super-pro-measurements.directive';
import superProAllMeasurementsMap from "./manual-devices/super-pro/super-pro-all-measurements-map";

import singleDevice from './cellular-spear/single-device.directive';
import cellularDeviceOverview from './cellular-spear/cellular-device-overview.directive';
import cellularDeviceNotes from './cellular-spear/cellular-device-notes.directive';
import cellularDeviceSettings from './cellular-spear/cellular-device-settings.directive';

export default angular.module('agrolog.farmer', [
    farmerDevices,
    devicesDashboard,
    deviceDashboardWidget,
    devicesMap,
    farmerPhoto,
    measurementsMap,
    allMeasurementsMap,
    farmerDeviceDetails,
    manualDevice,
    superProMeasurements,
    superProAllMeasurementsMap,
    singleDevice,
    cellularDeviceOverview,
    cellularDeviceNotes,
    cellularDeviceSettings])
    .name;